import { useNavigate }
	from "react-router-dom"
import { useSelector }
	from "react-redux"
import { solid }
	from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon }
	from "@fortawesome/react-fontawesome"

import Constants
	from "../../../../../constants"
import { RootState }
	from "./../../../../../globals"
import { styles }
	from "./style"
import { GeneralBalanceDTO } from "../../../../../models/GeneralBalanceDTO"
import { TelefonoVista } from "../../../../../components/phoneField"
import { dineroCorto } from "../../../../../utils/dineroCorto";

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	/**
	 * Student Data.
	 */
	student: any;
	/**
	 * balance data, positive balance, expired balance.
	 */
	balance: GeneralBalanceDTO;
	/** Registrar Pago, Cargar Productos y Transferir Saldo: a la derecha del título (en el teléfono, debajo). */
	actions?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ student, balance, actions }) => {
	const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value)
	const currentUserCampus: any = useSelector((state: RootState) => state.currentUserCampus.value)
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value)
	const navigate: any = useNavigate()

	return (
		<div style={styles.container}>
			<div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
				<div style={styles.header}>
					<button type="button"
						className="btn btn-default"
						disabled={idleLocked}
						onClick={() => navigate("/students")}>
						<FontAwesomeIcon icon={solid("chevron-left")} size="2x" />
					</button>
					<h3>
						{Constants.Screens.Finances.accountStatement.header}
					</h3>
				</div>
				{actions}
			</div>
			<div style={styles.studentDataRow}>
				<div style={styles.subtitleContainer}>
					<label style={styles.subtitle}>
						{Constants.Common.name}:
					</label>
					<span style={styles.studentDataText}>
						{student.firstName}
					</span>
				</div>
				<div style={styles.subtitleContainer}>
					<label style={styles.subtitle}>
						{Constants.Common.lastName}:
					</label>
					<span style={styles.studentDataText}>
						{student.lastName}
					</span>
				</div>
				<div style={styles.subtitleContainer}>
					<label style={styles.subtitle}>
						{Constants.Common.correlative}:
					</label>
					<span style={styles.studentDataText}>
						{student.identityCode}
					</span>
				</div>
				<div style={styles.subtitleContainer}>
					<label style={styles.subtitle}>
						Teléfono:
					</label>
					<span style={styles.studentDataText}>
						<TelefonoVista value={student.phone1} campusCountryId={campusRef?.[currentUserCampus]?.company?.country_id} />
					</span>
				</div>
				<div style={styles.subtitleContainer}>
					<label style={styles.subtitle}>
						{Constants.Common.observations}:
					</label>
					<span style={styles.studentDataText}>
						{student.observations}
					</span>
				</div>
			</div>
			<div style={styles.balanceContainer}>
				<div style={styles.financeTextContainer}>
					<span style={styles.financeText}>
						{Constants.Screens.Finances.accountStatement.subtitle}
					</span>
				</div>
				<div style={styles.balanceGrid}>
					<div style={styles.balanceRow}>
						<p style={styles.balanceText}>
							{Constants.Screens.Finances.accountStatement.dueMonthlyBalance}:
						</p>
						<p style={balance.expiredMonthlyBalance != null && balance.expiredMonthlyBalance.value > 0.009 ? styles.pendingAmount : styles.pendingAmountZero}>
							{balance.expiredMonthlyBalance != null ? dineroCorto(balance.expiredMonthlyBalance.moneyFormat) : "-"}
						</p>
					</div>
					<div style={styles.balanceRow}>
						<p style={styles.balanceText}>
							{Constants.Screens.Finances.accountStatement.monthlyBalance}:
						</p>
						<p style={styles.pendingAmountBlackText}>
							{balance.monthlyBalance != null ? dineroCorto(balance.monthlyBalance.moneyFormat) : "-"}
						</p>
					</div>
					<div style={styles.balanceRow}>
						<p style={styles.balanceText}>
							{Constants.Screens.Finances.accountStatement.productsBalance}:
						</p>
						<p style={balance.productsBalance != null && balance.productsBalance.value > 0.009 ? styles.pendingAmount : styles.pendingAmountZero}>
							{balance.productsBalance != null ? dineroCorto(balance.productsBalance.moneyFormat) : "-"}
						</p>
					</div>
					<div style={styles.balanceRow}>
						<p style={styles.balanceText}>
							{Constants.Screens.Finances.accountStatement.servicesBalance}:
						</p>
						<p style={balance.servicesBalance != null && balance.servicesBalance.value > 0.009 ? styles.pendingAmount : styles.pendingAmountZero}>
							{balance.servicesBalance != null ? dineroCorto(balance.servicesBalance.moneyFormat) : "-"}
						</p>
					</div>
					<div style={styles.balanceRow}>
						<p style={styles.balanceText}>
							{Constants.Screens.Finances.accountStatement.positiveBalance}:
						</p>
						<p style={styles.positiveBalance}>
							{balance.positiveBalance != null ? dineroCorto(balance.positiveBalance.moneyFormat) : "-"}
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Header